module.exports = __webpack_public_path__ + "circle-top.svg?d7c68343c8aa52b13a2719a8f176c548";